import { activeNavigation } from './activeNavigation';

const updatePushState = (url) => {
    history.pushState(null, '', `/${url}`);
    activeNavigation();
};

export {
    updatePushState
}